import { useNextStepPath } from './useSessionSteps';
import { Session, SessionStatus } from '@app/api';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useTheme } from 'react-jss';
import { Theme } from '@app/theme';

export const useRedirectIfDraft = (session: Session) => {
  const theme: Theme = useTheme();
  const navigate = useNavigate();
  const path = useNextStepPath(session);
  const isTablet = useMediaQuery({ query: theme.mediaContent.tablet });

  return useCallback(() => {
    if (session.status !== SessionStatus.DRAFT || !path) {
      if (isTablet) {
        navigate('review');
      }
      return;
    }
    navigate(path);
  }, [navigate, session, path, isTablet]);
};
